<template>
  <div :id="table.id" class="events product-table">
    <h2 v-if="table.title">{{ table.title }}</h2>

    <table class="table is-narrow">
      <thead>
      <tr>
        <th v-for="event in table.config" v-html="event.title">
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="event in table.data" class="field">
        <td v-for="field in table.config">
          <component
            :is="'tablefield-' + field.type"
            :config="_.get(field, 'config', {})"
            :data="_.get(event, field.path, '')"
            :product="event">
          </component>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import FieldMixin from "../table-field/FieldMixin"
import {Table} from "../../model/table/Table"

export default {
  name: 'table-report-events',
  mixins: [FieldMixin],
  props: {
    table: {
      required: true,
      type: Table
    }
  }
}
</script>



// WEBPACK FOOTER //
// TableReportEvents.vue?e3d1e076